import React, {Fragment} from 'react';
import CommanSidebar from "../common/commanSidebar";
import {Button, Card, CardHeader, CardTitle, CardBody, Col, Input, Label, Row} from "reactstrap";
import {Link} from "react-router-dom";
import DataTable from "react-data-table-component";
import Spinner from "../layout/Spinner";

const PermissionInfo = () => {
    return (
        <Fragment>
            <CommanSidebar/>
            <div className="content">
                <div className="row mt-lg-5 mt-0">
                    <div className="col-md-3">
                        <Card className="mt-5">
                            <CardHeader
                                className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                                <div className='d-flex mt-md-0 mt-1 justify-content-between'>
                                    <CardTitle tag='h4'>Site Admin</CardTitle>
                                </div>
                            </CardHeader>
                            <CardBody id="fix-height">
                                <ul>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can create Group</li>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can update Group</li>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can Deactive Group</li>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can assign Group owner</li>
                                </ul>
                            </CardBody>
                        </Card>
                    </div>
                    <div className="col-md-3">
                        <Card className="mt-5">
                            <CardHeader
                                className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                                <div className='d-flex mt-md-0 mt-1 justify-content-between'>
                                    <CardTitle tag='h4'>Group Owner / Group Admin</CardTitle>
                                </div>
                            </CardHeader>
                            <CardBody id="fix-height">
                                <ul>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can update Group (eg: add or remove member, change group name and group icon)</li>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can chat in Group</li>
                                </ul>
                            </CardBody>
                        </Card>
                    </div>
                    <div className="col-md-3">
                        <Card className="mt-5">
                            <CardHeader
                                className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                                <div className='d-flex mt-md-0 mt-1 justify-content-between'>
                                    <CardTitle tag='h4'>Agent</CardTitle>
                                </div>
                            </CardHeader>
                            <CardBody id="fix-height">
                                <ul>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can Leave Group</li>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can share property in Group</li>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can chat in Group</li>
                                </ul>
                            </CardBody>
                        </Card>
                    </div>
                    <div className="col-md-3">
                        <Card className="mt-5">
                            <CardHeader
                                className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                                <div className='d-flex mt-md-0 mt-1 justify-content-between'>
                                    <CardTitle tag='h4'>User</CardTitle>
                                </div>
                            </CardHeader>
                            <CardBody id="fix-height">
                                <ul>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can Leave Group</li>
                                    <li><i className="fa fa-arrow-right mr-2"/>Can chat in Group</li>
                                </ul>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default PermissionInfo;
